import antd from 'ant-design-vue/es/locale-provider/pl_PL';
import dayjsLocale from 'dayjs/locale/pt';
import momentEnCA from 'moment/dist/locale/en-ca';
import data from '../json/pt.json';

const components = {
  antLocale: antd,
  momentName: 'eu',
  momentLocale: momentEnCA,
  dayjsName: 'pt',
  dayjsLocale
};

export default {
  ...components,
  ...data
};
